import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {AppComponent} from '../../app.component';
import {ModalTypes} from "../../enums/modal-types";
import {ModalTemplates} from "../../enums/modal-templates";
import {MenuHeaderLabels, MenuHeaderPaths} from '../../enums/menu-header';
import {RouterLinks} from "../../enums/router-links";
import {AuthGuard} from "../../helpers/auth-guard.helper";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./header.component.less']
})

export class HeaderComponent implements OnInit {
  menu: any[] = [];
  global_texts: any = null;
  header_title: string = '';
  role_admin: boolean = sessionStorage.getItem('role_admin') === 'true' || false;

  constructor(
    public app: AppComponent,
    private router: Router,
    private authGuard: AuthGuard
  ) {
  }

  ngOnInit(): void {
    this.menu = this.app.sharedHelper.constructMenu(MenuHeaderLabels, MenuHeaderPaths);
    console.log("role_admin ==> ", this.role_admin);

    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      console.log("texts ==> ", texts);
      this.global_texts = texts;
      this.header_title = this.global_texts.header.text_bar;
      this.getHeaderTitle();
    });
  }

  getHeaderTitle() {
    let module_uuid = this.app.sharedHelper.getModuleUuidFromUrl();
    let ref_page = this.app.sharedHelper.getRefPageFromUrl();
    let module = this.app.sharedHelper.getFrontDatasForModuleByUuid(module_uuid);
    //let title = '';
    if (module && module.screens) {
      // Get the title from module.screens by ref_page
      let screen = module.screens.find((s: any) => s.ref === ref_page);
      console.log("screen => ", screen)
      this.header_title = screen?.title ? screen.title : this.global_texts.header.text_bar;
    }
  }

  logout(): void {
    this.app.dialogService.confirmThis(
      this.global_texts?.modals?.logout.title,
      this.global_texts?.modals?.logout.message,
      ModalTypes.Confirm,
      ModalTemplates.Confirmation,
      () => {
        this.authGuard.isLogoutClicked = true;
        // Delete all session storage
        //localStorage.clear();
        sessionStorage.clear();
        // Redirect to Modules List
        this.router.navigate([RouterLinks.Login]);
      },
      () => { // Code to execute on NO
      });
  }

  downloadCsv(): void {
    this.app.apiService.downloadStats().subscribe(response => {
      // Extraction du nom de fichier depuis l'en-tête Content-Disposition
      const contentDisposition = response.headers.get('content-disposition');
      const filename = this.getFilenameFromContentDisposition(contentDisposition) || 'statistiques.csv';

      // Création du Blob à partir de la réponse
      const blob = response.body;
      if (blob) {
        this.downloadFile(blob, filename); // Appel de la fonction de téléchargement
      } else {
        console.error('Aucun fichier reçu');
      }
    }, error => {
      console.error('Erreur lors du téléchargement du fichier', error);
    });
  }

  downloadNewStats(): void {
    /**
     * TODO: Implement the downloadNewStats method
     * This method should handle the download of new statistics
     * Depending on the API, it might look similar to downloadCsv
     * **/
    this.app.apiService.downloadUserStats().subscribe(response => {
      // Extraction du nom de fichier depuis l'en-tête Content-Disposition
      const contentDisposition = response.headers.get('content-disposition');
      const filename = this.getFilenameFromContentDisposition(contentDisposition) || 'statistiques_users.csv';

      // Création du Blob à partir de la réponse
      const blob = response.body;
      if (blob) {
        this.downloadFile(blob, filename); // Appel de la fonction de téléchargement
      } else {
        console.error('Aucun fichier reçu');
      }
    }, error => {
      console.error('Erreur lors du téléchargement du fichier', error);
    });
  }

  private getFilenameFromContentDisposition(contentDisposition: string | null): string | null {
    if (!contentDisposition) return null;
    const matches = contentDisposition.match(/filename="([^"]+)"/);
    return matches ? matches[1] : null;
  }

  private downloadFile(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob); // Création d'une URL Blob pour le téléchargement
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url); // Révocation de l'URL Blob pour libérer la mémoire
  }
}
